// hooks/orderAlerts.js
// New-order notifications, recognised by the fixed titles the shops send to admins
// (services/marketService.js alertOwner('New order', 'MKT-… — …') and
// services/dwisendShopService.js alertOwner('New CD shop order — set the delivery fee', 'DSO-…: …')).
// Display only — nothing here changes an order.

const UG_TITLE = /^New order$/;
const DRC_TITLE = /^New [A-Z]{2} shop order\b/;
const REF = /\b(MKT-[A-Z0-9-]+|DSO-[A-Z0-9]+)\b/;

// → { id, market: 'UG' | 'DRC', ref, title, body, createdAt } or null
export function asOrderAlert(n) {
  if (!n) return null;
  const title = String(n.title || '');
  const market = UG_TITLE.test(title) ? 'UG' : DRC_TITLE.test(title) ? 'DRC' : null;
  if (!market) return null;
  const ref = (String(n.body || n.message || '').match(REF) || [])[1] || null;
  return { id: n._id, market, ref, title, body: n.body || n.message || '', createdAt: n.createdAt };
}

export const orderAlertsFrom = (notifications = []) =>
  notifications.filter(n => n && n.isRead !== true).map(asOrderAlert).filter(Boolean);

// Notifications page groups.
const PAYMENT_WORDS = /payment|paid|withdraw|deposit|transfer|refund/i;
export function categoryOf(n) {
  if (asOrderAlert(n)) return 'orders';
  if (['wallet', 'transaction'].includes(n.type) || PAYMENT_WORDS.test(String(n.title || ''))) return 'payments';
  return 'other';
}

// Orders with an unread new-order alert first (newest first among them); the rest keep their order.
export function pinNew(orders = [], newRefs = new Set(), refKey = 'orderRef') {
  const isNew = o => newRefs.has(o[refKey]);
  return [...orders.filter(isNew), ...orders.filter(o => !isNew(o))];
}
